export { default as deletePaymentMethod } from './deletePaymentMethod';
export { default as getPaymentMethodsForPerson } from './getPaymentMethodsForPerson';
export { default as setAsDefaultPaymentMethod } from './setAsDefaultPaymentMethod';
